import moment from "moment";

export const formatDate = (timestamp, format = "ddd, MMM Do YYYY, hA") => {
    const date = moment(timestamp).format(format);
    return date;
}

export const moneyFormat = (number) => {
    return number;
}


export const  filterCountries = (countries) => {
    const countryState = Object.values(countries);
    let countryNames = [];
    for (const country of countryState) {
        if (country.name) {
            countryNames.push(country.name)
        }
    }

    return countryNames;
}

export const truncateString = (string, limit = 30) => {
    if (string.length <= limit) {
        return string
    }
    return string.slice(0, limit) + '...'
}